// Zapnutie service workera a upozornenie na novu verziu.
//
// Povodny src/serviceWorker.js z Create React App mieri na /service-worker.js,
// ktory sa v tomto projekte nikdy nevyrabal (nie je tu workbox), takze
// register() by len hladal neexistujuci subor. Preto vlastna registracia
// na /sw.js, ktory lezi v public/ a kopiruje sa do buildu.

export const zapniServiceWorker = ({ naNovuVerziu } = {}) => {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/sw.js`)
      .then((registracia) => {
        // Po kazdom otvoreni sa pozrie, ci nie je novsi build, a necha
        // service workera upratat subory po starych verziach. Sam sw.js sa
        // medzi nasadeniami nemeni, takze prehliadac by inac install ani
        // activate uz nikdy nespustil.
        navigator.serviceWorker.ready
          .then((r) => {
            if (r.active) r.active.postMessage("skontroluj-verziu");
          })
          .catch(() => undefined);

        registracia.addEventListener("updatefound", () => {
          const novy = registracia.installing;
          if (!novy) return;
          novy.addEventListener("statechange", () => {
            // controller je null pri prvom otvoreni, vtedy sa nic nehlasi.
            if (
              novy.state === "installed" &&
              navigator.serviceWorker.controller &&
              typeof naNovuVerziu === "function"
            ) {
              naNovuVerziu(() => {
                novy.postMessage("prevziat-novu-verziu");
                window.location.reload();
              });
            }
          });
        });
      })
      .catch(() => undefined);
  });
};

export default zapniServiceWorker;
